import React, { useState, useEffect } from "react"
import TableHolder from "../components/TableHolder"
import {
  Button,
  Modal,
  Table,
  Card,
  Input,
  Dimmer,
  Loader,
  Radio,
  Icon,
} from "semantic-ui-react"
import { useTranslation } from "react-i18next"
import { apiGet, apiPost, apiPut, apiDelete } from "../utils/apiConnector"
import { productListApi, productApi } from "../config/apiUrls"
import { useDispatch, useSelector } from "react-redux"

const ProductPage = (props) => {
  const [isLoading, setIsLoading] = useState(false)
  const [barcode, setBarcode] = useState("")
  const [name, setName] = useState("")
  const [amountBox, setAmountBox] = useState("")
  const [amountPalette, setAmountPalette] = useState("")
  const [modal, setModal] = useState(false)
  const [edit, setEdit] = useState(false)
  const [isInner, setIsInner] = useState(false)
  const [products, setProducts] = useState([])
  const [product, setProduct] = useState({})
  const { profile } = useSelector((state) => ({ profile: state.profile }))
  const getProducts = () => {
    const storeId = profile.stores.length ? profile.stores[0].id : 0
    if (storeId) {
      setIsLoading(true)
      apiGet(productListApi + "/" + storeId, {})
        .onOk((res) => {
          console.log(res.data.response)
          setProducts(res.data.response)
        })
        .onFail(() => {})
        .afterAll(() => {
          setIsLoading(false)
        })
        .startSingle()
    }
  }
  const createProduct = () => {
    const storeId = profile.stores.length ? profile.stores[0].id : 0
    if (storeId) {
      const req = {}
      req.barcode = barcode
      req.name = name
      req.storeId = storeId
      if (amountPalette === "" && amountBox === "") return
      req.amountBox = parseInt(amountBox)
      req.amountPalette = parseInt(amountPalette)
      apiPost(productApi, req)
        .onOk((res) => {
          console.log(res.data.response)
          // setProducts(res.data.response)
          getProducts()
        })
        .onFail(() => {})
        .afterAll(() => {
          getProducts()
          setName("")
          setBarcode("")
          setAmountPalette("")
          setAmountBox("")
          setModal(false)
        })
        .startSingle()
    } else {
      setName("")
      setBarcode("")
      setAmountPalette("")
      setAmountBox("")
    }
    setModal(false)
  }
  const { t } = useTranslation()
  const config = {
    fname: t("Products"),
    data: products,
    headers: [
      { name: "barcode", title: "GTIN" },
      // { name: "id", title: "ID" },
      // { name: "orderId", title: "Order ID" },
      { name: "name", title: "productName" },
      // { name: "qty", title: "Quantity" },
      // { name: "status", title: "Status" },
      // { name: "dtt", title: "Date" },
      // { name: "available", title: "Available" },amountBox,amountPalette
      { name: "amountBox", title: "amountBox" },
      { name: "amountPalette", title: "amountPalette" },
    ],
    isLoading: () => isLoading,
    onClick: (id) => {
      const plist = products.filter((q) => q.id === id)
      if (plist.length) {
        console.log(plist[0])
        setProduct(plist[0])
        setName(plist[0].name)
        setBarcode(plist[0].barcode)
        setAmountBox(plist[0].amountBox)
        setAmountPalette(plist[0].amountPalette)
        setIsInner(true)
      }
    },
  }
  const renderInner = () => {
    return (
      <>
        <Modal
          open={isInner}
          onClose={() => {
            setProduct({})
            setIsInner(false)
            setName("")
            setBarcode("")
            setAmountBox("")
            setAmountPalette("")
          }}
          style={{ marginTop: "-40vh", height: "max-content" }}
          size="small"
        >
          <Card fluid>
            <Card.Content>
              <div style={{ display: "flex", alignItems: "center" }}>
                <h4>{t("productInformation")}</h4>
                <Icon
                  name="edit"
                  size="big"
                  style={{ marginLeft: 10 }}
                  onClick={() => {
                    setEdit(!edit)
                  }}
                />
                <Icon
                  name="trash"
                  size="big"
                  style={{ marginLeft: 10 }}
                  onClick={() => {
                    apiDelete(productApi + "/" + product.id, {})
                      .onOk((res) => {
                        console.log(res.data.response)
                      })
                      .onFail(() => {})
                      .afterAll(() => {
                        getProducts()
                        setProduct({})
                        setIsInner(false)
                      })
                      .startSingle()
                  }}
                />
              </div>
              {edit ? (
                <>
                  <div>
                    <div>
                      <div>{t("Name")}:</div>
                      <div>
                        <Input
                          value={name}
                          // placeholder={product.name}
                          onChange={(e, d) => {
                            setName(d.value)
                          }}
                        />
                      </div>
                    </div>
                    <div style={{ marginTop: 10 }}>
                      <div>{t("Barcode")}:</div>
                      <div>
                        <Input
                          value={barcode}
                          type="number"
                          // placeholder={product.barcode}
                          onChange={(e, d) => {
                            setBarcode(d.value)
                          }}
                        />
                      </div>
                    </div>
                    <div style={{ marginTop: 10 }}>
                      <div>{t("amountBox")}:</div>
                      <div>
                        <Input
                          value={amountBox}
                          type="number"
                          // placeholder={product.amountBox}
                          onChange={(e, d) => {
                            setAmountBox(d.value)
                          }}
                        />
                      </div>
                    </div>
                    <div style={{ marginTop: 10 }}>
                      <div>{t("amountPalette")}:</div>
                      <div>
                        <Input
                          value={amountPalette}
                          // placeholder={product.amountPalette}
                          onChange={(e, d) => {
                            setAmountPalette(d.value)
                          }}
                        />
                      </div>
                    </div>
                    <div style={{ marginTop: 10 }}>
                      <Button
                        content={t("Save")}
                        positive
                        onClick={() => {
                          const storeId = profile.stores.length
                            ? profile.stores[0].id
                            : 0
                          if (storeId) {
                            const req = {}
                            req.id = product.id
                            req.barcode =
                              barcode === "" ? product.barcode : barcode
                            req.name = name === "" ? product.name : name
                            req.storeId = storeId
                            req.amountBox =
                              amountBox !== ""
                                ? parseInt(amountBox)
                                : product.amountBox
                            req.amountPalette =
                              amountPalette !== ""
                                ? parseInt(amountPalette)
                                : product.amountPalette
                            apiPut(productApi, req)
                              .onOk((res) => {
                                console.log(res.data.response)
                                // setProducts(res.data.response)
                              })
                              .onFail(() => {})
                              .afterAll(() => {
                                getProducts()
                                setName("")
                                setBarcode("")
                                setAmountPalette("")
                                setAmountBox("")
                                setModal(false)
                              })
                              .startSingle()
                          } else {
                            setName("")
                            setBarcode("")
                            setAmountPalette("")
                            setAmountBox("")
                          }
                          setIsInner(false)
                        }}
                      />
                    </div>
                  </div>
                </>
              ) : (
                <Table style={{ border: "0px solid red" }}>
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell>
                        <b>{t("Name")}:</b>
                      </Table.Cell>
                      <Table.Cell>{product.name}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>
                        <b>{t("Barcode")}:</b>
                      </Table.Cell>
                      <Table.Cell>{product.barcode}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>
                        <b>{t("amountBox")}:</b>
                      </Table.Cell>
                      <Table.Cell>{product.amountBox}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>
                        <b>{t("amountPalette")}:</b>
                      </Table.Cell>
                      <Table.Cell>{product.amountPalette}</Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              )}
            </Card.Content>
          </Card>
        </Modal>
      </>
    )
  }
  useEffect(() => {
    getProducts()
    return () => {}
  }, [])
  const renderModal = () => {
    return (
      <>
        <Modal
          open={modal}
          onClose={() => {
            setName("")
            setBarcode("")
            setAmountBox("")
            setAmountPalette("")
            setModal(false)
          }}
          style={{ height: "max-content", marginTop: "-40vh" }}
          size="small"
        >
          <Card fluid>
            <Card.Content>
              <h3>{t("createProduct")}</h3>
              <Table fluid style={{ border: "0px solid red" }}>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell style={{ width: 200 }}>
                      <b>{t("productName")}</b>
                    </Table.Cell>
                    <Table.Cell>
                      <Input
                        placeholder={t("productName")}
                        fluid
                        value={name}
                        onChange={(e, d) => {
                          setName(d.value)
                        }}
                      />
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row style={{ display: "none" }}>
                    <Table.Cell>
                      <b>{t("productId")}</b>
                    </Table.Cell>
                    <Table.Cell>
                      <Input placeholder={t("productId")} fluid />
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <b>{t("productGtin")}</b>
                    </Table.Cell>
                    <Table.Cell>
                      <Input
                        placeholder={t("productGtin")}
                        fluid
                        value={barcode}
                        onChange={(e, d) => {
                          setBarcode(d.value)
                        }}
                      />
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell style={{ width: 200 }}>
                      <b>{t("amountBox")}</b>
                    </Table.Cell>
                    <Table.Cell>
                      <Input
                        placeholder={t("amountBox")}
                        fluid
                        value={amountBox}
                        type="number"
                        onChange={(e, d) => {
                          setAmountBox(d.value)
                        }}
                      />
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell style={{ width: 200 }}>
                      <b>{t("amountPalette")}</b>
                    </Table.Cell>
                    <Table.Cell>
                      <Input
                        placeholder={t("amountPalette")}
                        fluid
                        value={amountPalette}
                        type="number"
                        onChange={(e, d) => {
                          setAmountPalette(d.value)
                        }}
                      />
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <Button
                  positive
                  content={t("Create")}
                  onClick={createProduct}
                  disabled={!name || !barcode}
                />
              </div>
            </Card.Content>
          </Card>
        </Modal>
      </>
    )
  }
  useEffect(() => {
    return () => {}
  })
  return (
    <>
      <div>
        <h2>{t("Products")}</h2>
        <Button
          content={t("createProduct")}
          positive
          style={{ marginTop: 10, marginBottom: 10 }}
          onClick={() => {
            setModal(true)
          }}
        />
        <TableHolder config={config} />
        {renderModal()}
        {renderInner()}
      </div>
    </>
  )
}

export default ProductPage
